import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusFlash: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFocusFlash"><Path d="M8.75 3H3V8.75H4.5V4.5H8.75V3Z" fill="currentColor"/><Path d="M21 3H15.25V4.5H19.5V8.75H21V3Z" fill="currentColor"/><Path d="M4.5 19.5V15.25H3V21H8.75V19.5H4.5Z" fill="currentColor"/><Path d="M21 21V15.25H19.5V19.5H15.25V21H21Z" fill="currentColor"/><Path d="M10.8532 11.2501L13.0335 7.76155L11.7615 6.96655L8.14685 12.7501H13.1469L10.9665 16.2386L12.2385 17.0335L15.8532 11.2501H10.8532Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFocusFlash;
